import { tw } from "@careinfo/tailwind";
import { useRef } from "react";
import Button from "../Reusable/Button";

const CreateInvoiceForm = (props: any) => {
  const {
    handleCreate,
    isLoading,
    user,
    setError,
    getValues,
    invoiceReport,
    setData,
  } = props;

  const debounceRef = useRef(false);

  const handleGenerateClick = () => {
    if (debounceRef.current) return;
    debounceRef.current = true;
    handleCreate(user, getValues(), setError);
    setData([]);
    setTimeout(() => {
      debounceRef.current = false;
    }, 2000);
  };

  return (
    <>
      <div className="flex justify-between mt-10">
        <div>Total Number of order:</div>
        <div>{invoiceReport?.total_order}</div>
      </div>
      <div className="flex justify-between mt-2">
        <div>Total Collected COD:</div>
        <div>{invoiceReport?.collected_cod}</div>
      </div>
      <div className="flex justify-between mt-2">
        <div>Commision:</div>
        <div>{invoiceReport?.commission ?? 0}</div>
      </div>
      <div className="flex justify-between mt-2">
        <div>Total Delivery Charge:</div>
        <div>{invoiceReport?.delivery_charge}</div>
      </div>
      <div className="flex justify-between mt-2">
        <div>Total Tax Amount:</div>
        <div>{invoiceReport?.tax_amount ?? 0}</div>
      </div>
      <div className="flex justify-between mt-2">
        <div>Total Amount After Tax:</div>
        <div>{invoiceReport?.amount_after_tax}</div>
      </div>
      <div className="flex justify-between mt-2 font-bold">
        <div>Net Payable</div>
        <div>{invoiceReport?.payable_amount}</div>
      </div>
      <div className={tw`mx-auto`}>
        <div className={tw`w-40`}>
          <Button
            label={"Generate Statement"}
            isLoading={isLoading}
            onClick={handleGenerateClick}
          />
        </div>
      </div>
    </>
  );
};

export default CreateInvoiceForm;
